import { createSlice } from "@reduxjs/toolkit";

import { replaceById } from "./listHelpers";

const notesSlice = createSlice({
  name: "notes",
  initialState: [],
  reducers: {
    notesAdd(state, action) {
      return action.payload;
    },
    createNoteItem(state, action) {
      return [...state, action.payload];
    },
    updateNoteItem(state, action) {
      const updatedNote = action.payload;
      const itemIndex = state.findIndex(note => note.id === updatedNote.id);
      if (itemIndex !== -1) {
        state[itemIndex] = updatedNote;
      }
    },
    moveMultipleNoteItemsBetweenAdminItemSlice(state, action) {
      replaceById(state, action.payload);
    },
    deleteNoteItem(state, action) {
      const noteId = action.payload;
      return state.filter(note => note.id !== noteId);
    },
    updateNoteStatus(state, action) {
      const { id: noteId, status } = action.payload;

      const noteItemIndex = state.findIndex(item => item.id === noteId);
      if (noteItemIndex !== -1) {
        state[noteItemIndex].status = status;
      }
    },
  },
});

export const {
  notesAdd,
  createNoteItem,
  updateNoteItem,
  deleteNoteItem,
  updateNoteStatus,
  moveMultipleNoteItemsBetweenAdminItemSlice,
} = notesSlice.actions;

export default notesSlice.reducer;
